<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>RI Company Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex class="mt-3" xs12>
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text v-if="intermediaryMode">
            <v-data-table
              :headers="interHeaders"
              :items="interItems"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.inter }}</td>
                  <td class="text-xs-left">{{ row.item.name }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
          <v-card-text v-else-if="treatyMode">
            <v-data-table
              :headers="treatyHeaders"
              :items="treatyItems"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                  <td class="text-xs-left">{{ row.item.ttyDesc }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
          <v-card-text v-else>
            <v-spacer></v-spacer>
            <v-flex class="mt-3" xs12>
              <v-text-field v-model="noRiTypeText" readonly solo></v-text-field>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  props: {
    riType: String
  },
  data() {
    return {
      interHeaders: [{ text: 'Intermediary', value: 'inter' }, { text: 'Description', value: 'name' }, TableConst.tableActionHeader],
      treatyHeaders: [{ text: 'Treaty No.', value: 'ttyNo' }, { text: 'Description', value: 'ttyDesc' }, TableConst.tableActionHeader],
      intermediaryMode: false,
      treatyMode: false,
      interItems: [],
      treatyItems: [],
      noRiTypeText: 'Please Select a RI Type to Proceed',
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    if (this.riType === 'C' || this.riType === 'F') {
      this.intermediaryMode = true
      this.doInterInit()
    } else if (this.riType === 'D' || this.riType === 'T' || this.riType === 'W') {
      this.treatyMode = true
      this.doTreatyInit()
    }
  },
  computed: {
    menu() {
      return this.$store.state.coRIPanelParam.menu
    }
  },
  methods: {
    doInterInit() {
      const apiURI = this.menu.getRiCoHelpListCF
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.map((riCoMap) => {
                const convertList = {
                  inter: riCoMap.inter,
                  name: riCoMap.name
                }
                this.interItems.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doTreatyInit() {
      const apiURI = this.menu.getRiCoHelpListDTW
      if (apiURI) {
        this.loading = true
        try {
          const expand = { riType: this.riType }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            data.map((treatyMap) => {
              const convertList = {
                ttyNo: treatyMap.ttyNo,
                ttyDesc: treatyMap.ttyDesc
              }
              this.treatyItems.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(obj) {
      if (this.intermediaryMode === true) {
        const interObj = {
          riCo: obj,
          from: 'inter'
        }
        this.$emit('doAssign', interObj)
        this.$emit('close')
      } else if (this.treatyMode === true) {
        const treatyObj = {
          riCo: obj,
          from: 'treaty'
        }
        this.$emit('doAssign', treatyObj)
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
